<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Médicos</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Médico</th>
                <th>Total de consultas</th>
                <th>Total cancelado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="doctor in doctores" :key="doctor.id">
                <td>{{ doctor.doctor }}</td>
                <td>{{ moneyFormat(doctor.valor_total_consultas) }}</td>
                <td>{{ moneyFormat(doctor.valor_total_cancelado) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="$emit('cerrar')" class="btn-danger">
        <i class="fa fa-ban"></i>
        <span>Cerrar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      doctores: [],
      moneyFormat: moneyFormat
    };
  },
  mounted: function() {
    let that = this;
    axios
      .get(url + "/cierre-pago/" + this.id + "/doctores")
      .then(function(response) {
        that.doctores = response.data;
      })
      .catch(function() {
        swal("Hubo un error, intente nuevamente.", "Aviso", "warning");
      });
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/procesos/DoctoresCierrePago.vue